import React from "react";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Error from "../../../components/Error";

const useStyles = makeStyles(() => ({
  icon: {
    borderRadius: "50%",
    border: "2px solid",
    borderColor: "inherit",
    paddingTop: 15,
    height: 70,
    width: 70,
  },
  textContainer: {
    display: "block",
    width: "100%",
    marginTop: 50,
    marginBottom: 20,
  },
}));

export default function TemporaryPage() {
  const classes = useStyles();

  return (
    <>
      <Error icon={"cog"} iconProps={{ className: classes.icon }}>
        Currently the website is under maintenance.
        <Typography variant={"caption"} className={classes.textContainer}>
          As soon as all the improvements will be finalised, you will receive a
          notification regarding the approval of your account, and you will be
          able to choose and apply to the preferred educational institution.
        </Typography>
      </Error>
    </>
  );
}
